module.exports = "/_next/static/images/cacat-total-ccSVG-b21a24c60f239669e6bb41f6f288ce6c.svg";